import HistorialLeccionesRow from "./HistorialLeccionesRow";

const HistorialLeccionesTable = ({ currentData, onVerHistorial }) => {
  return (
    <table className="w-full table-auto border-separate">
      <thead className="sticky top-0 z-10 bg-backgroundColor">
        <tr className="text-left font-semibold font-sans text-black">
          <th className="pl-4 pr-2">Identificador</th>
          <th className="px-2">Nombre de la lección</th>
          <th className="text-center">Tipo</th>
          <th className="text-center">Última modificación</th>
          <th className="text-center">Movimientos</th>
          <th className="text-center">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {currentData?.map((leccion) => (
          <HistorialLeccionesRow
            key={leccion?.uma?._id}
            leccion={leccion}
            onVerHistorial={onVerHistorial}
          />
        ))}
      </tbody>
    </table>
  );
};

export default HistorialLeccionesTable;
